import React from 'react';
import { createDevTools } from 'redux-devtools';
import LogMonitor from 'redux-devtools-log-monitor';
import DockMonitor from 'redux-devtools-dock-monitor';

// To use the Keys below, preface with Ctrl (e.g. Ctrl+H, Ctrl+W)
export default createDevTools(
	<DockMonitor toggleVisibilityKey="ctrl-h"
							 changePositionKey="ctrl-w"
							 defaultIsVisible={false}>
		<LogMonitor />
	</DockMonitor>
);



// WEBPACK FOOTER //
// ./src/assets/js/containers/DevTools.js